/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react'
import { NetworkStatus, useQuery } from "@apollo/client";
import { GET_DATA } from '../../../Query/ListingQuery';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../Components/Loader/Loader';
const CopartListing = () => {
    const [isMoreData, setIsMoreData] = useState(true)
    const navigate = useNavigate()
    const { data, loading, error, fetchMore, networkStatus } = useQuery(GET_DATA, {
        variables: {
            skip: 0,
            take: 21,
            type: "coopart"
        }
    });
    const CoprtData = data?.vehicles || []
    console.log(CoprtData, "data")

    console.log(data, 'alllisting')

    const handleFetchMore = useCallback(() => {
        if (NetworkStatus.ready === networkStatus && isMoreData) {
            fetchMore({
                variables: {
                    skip: CoprtData?.length,
                    take: 21,
                    type: "coopart"
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                    setIsMoreData(
                        fetchMoreResult && fetchMoreResult.CoprtData?.length !== 0
                    );
                    if (!fetchMoreResult) {
                        return prev;
                    }
                    return {
                        ...prev,
                        vehicles: [
                            ...prev?.vehicles,
                            ...fetchMoreResult?.vehicles,
                        ],
                    };
                },
            });
        }
    }, [data?.vehicles?.length, fetchMore, isMoreData, networkStatus]);

    useEffect(() => {
        window.addEventListener("scroll", function () {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
                console.log("Last page");
                handleFetchMore(); // Show loading spinner and make fetch request to api
            }
        });
    }, [handleFetchMore]);

    return (
        <>
            <InfiniteScroll

                dataLength={CoprtData?.length || []} // This is important field to render the next data
                next={handleFetchMore}
                hasMore={isMoreData}
                inverse={true}
                loader={<Loader />}
                style={{ overflowX: "hidden" }}
                endMessage={
                    <p style={{ textAlign: 'center' }}>
                        <b>Yay! You have seen it all</b>
                    </p>
                }
            ><section>
                    <div className='container'>
                        <div className='row'>
                            {CoprtData?.map((e) => {
                                return (
                                    <>
                                        <div className='col-md-4'>
                                            <div class="car-item wow fadeInUp" data-wow-delay=".25s">
                                                <div class="car-img">
                                                    <span class="car-status status-1">Used</span>
                                                    <img src={e?.carImages?.length > 0 ? e?.carImages[0] : '/assets/img/car/01.jpg'} alt="" />
                                                    <div class="car-btns">
                                                        <a href="#"><i class="far fa-heart"></i></a>
                                                        <a href="#"><i class="far fa-arrows-repeat"></i></a>
                                                    </div>
                                                </div>
                                                <div class="car-content">
                                                    <div class="car-top">
                                                        <h4><a href="#">{e?.vehicleDetails?.length > 0 && e?.title}</a></h4>
                                                        <div class="car-rate">
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <i class="fas fa-star"></i>
                                                            <span>5.0 (58.5k Review)</span>
                                                        </div>
                                                    </div>
                                                    <ul class="car-list">
                                                        <li><i class="far fa-steering-wheel"></i>{e?.vehicleDetails?.length > 0 && e?.vehicleDetails[0]?.Transmission}</li>
                                                        <li><i class="far fa-road"></i>{e?.vehicleDetails?.length > 0 && e?.vehicleDetails[0]?.EngineType}</li>
                                                        <li><i class="far fa-car"></i>Model: 2023</li>
                                                        <li><i class="far fa-gas-pump"></i>{e?.vehicleDetails?.length > 0 && e?.vehicleDetails[0]?.Fuel}</li>
                                                    </ul>
                                                    <div class="car-footer ">
                                                        {e?.bidInformation?.length > 0 && e?.bidInformation[0]?.TimeLeft === null ?
                                                            <div className=''>
                                                                <label className='text-dark'> Current Bid</label>
                                                                <h6 class="car-price">$ {e?.bidInformation?.length > 0 && e?.bidInformation[0]?.CurrentBid}</h6>
                                                            </div>
                                                            : e?.bidInformation?.length > 0 && e?.bidInformation[0]?.TimeLeft !== null && e?.bidInformation[0]?.CurrentBid !== null ?
                                                                <>
                                                                    <div >
                                                                        <label className='text-dark'>Auction In</label>
                                                                        <h6 class="car-price">{e?.bidInformation?.length > 0 && e?.bidInformation[0]?.TimeLeft}</h6>
                                                                    </div>
                                                                    <div >

                                                                        <label className='text-dark'> Current Bid</label>
                                                                        <h6 class="car-price">$ {e?.bidInformation?.length > 0 && e?.bidInformation[0]?.CurrentBid}</h6>
                                                                    </div>
                                                                    <button class="theme-btn me-2" onClick={() => navigate(`/detail/${e?.id}`)}>Bid Now</button>
                                                                </>
                                                                : null}
                                                    </div>
                                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                                        <div className="">
                                                            <button class="theme-btn" onClick={() => navigate(`/detail/${e?.id}`)}>Buy it Now</button>
                                                            <h6 class="car-price mt-1">$ {e?.price}</h6>
                                                        </div>
                                                        <button class="theme-btn" onClick={() => navigate(`/detail/${e?.id}`)}><span class="far fa-eye"></span>Details</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </section >
            </InfiniteScroll>
        </>
    )
}

export default CopartListing